import axiosHandler from "./axios-handler";

const getCourse = async ({ courseEntryUid }) => {
  
  const options = {
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseEntryUid}`,
    withCredentials: true,
  }

  if (courseEntryUid) {
    const response = await axiosHandler(options);
    return response;
  }

  return;
}

const getLesson = async ({ courseEntryUid, lessonEntryUid }) => {

  const options = {
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseEntryUid}/lessons/${lessonEntryUid}`,
    withCredentials: true,
  }

  if (lessonEntryUid) {
    const response = await axiosHandler(options);
    return response;
  }

  return;

}


export default async function getUserActivity({ courseEntryUid, lessonEntryUid }) {

  let coursePath = window.location.pathname.replace(/^\//, '').split('/').length

  let courseData, lessonData;

  // if (coursePath === 3) {
    courseData = await getCourse({ courseEntryUid });
  // }
  // else if (coursePath === 4) {
    lessonData = await getLesson({ courseEntryUid, lessonEntryUid });
  // }

  const isCourse = coursePath === 3 ? true : false;
  return { courseData, lessonData, isCourse };
}
